<app-access-manager [namespace]="namespace">

<div style="max-width: 800px; margin-right: 20px;">
  <app-page-header
    [iconType]="'Settings'"
    [text]="'Settings'"
  ></app-page-header>
  @if (allowViewRoles) { <app-role-admin/> }
  @if (allowViewBrands) { <app-merchant-brands/> }
  @if (allowViewGroups) { <app-merchant-groups /> } 
  <app-feature-flags />
</div>

</app-access-manager>